import classNames from 'classnames';
import { FC } from 'react';
import { RowLabel } from '../rowLabels';

/**
 * Rail colour roles per label (CMS-1906 requirement 2.5): fill is the -1 step, the right edge the
 * -2 step, the word the -4 step. Full class strings so Tailwind's content scan picks them up.
 */
export const ROW_LABEL_RAIL_CLASSES: Record<
  RowLabel,
  { cell: string; word: string }
> = {
  OUR_PICK: {
    cell: '!bg-colors/campaign-blue-1 border-r border-r-colors/campaign-blue-2',
    word: 'text-colors/campaign-blue-4',
  },
  EXCLUSIVE: {
    cell: '!bg-colors/campaign-red-1 border-r border-r-colors/campaign-red-2',
    word: 'text-colors/campaign-red-4',
  },
  ENDS_SOON: {
    cell: '!bg-colors/campaign-orange-1 border-r border-r-colors/campaign-orange-2',
    word: 'text-colors/campaign-orange-4',
  },
  FLASH_DEAL: {
    cell: '!bg-colors/campaign-yellow-1 border-r border-r-colors/campaign-yellow-2',
    word: 'text-colors/campaign-yellow-4',
  },
  NEW: {
    cell: '!bg-colors/campaign-green-1 border-r border-r-colors/campaign-green-2',
    word: 'text-colors/campaign-green-4',
  },
};

export const isCjkLang = (lang: string): boolean => lang.startsWith('zh');

type RowLabelRailProps = {
  label: RowLabel;
  text: string;
  lang: string;
};

/**
 * A Latin label reads bottom to top (vertical-rl rotated 180°); a CJK label keeps its natural
 * top-to-bottom form at 12px because the glyphs are denser than Latin (CMS-1906).
 */
export const RowLabelRail: FC<RowLabelRailProps> = ({ label, text, lang }) => (
  <span
    data-component="ComparisonTableRowLabel"
    data-row-label={label}
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    className={classNames(
      'block whitespace-nowrap font-bold uppercase leading-none tracking-[0.02em]',
      '[writing-mode:vertical-rl]',
      isCjkLang(lang) ? 'text-[12px]' : 'rotate-180 text-[11px]',
      ROW_LABEL_RAIL_CLASSES[label]?.word,
    )}
  >
    {text}
  </span>
);
